<div class="wrapper">
    <div class="m-box">
      <h2>
        <!-- Private Price List -->
        {{'appointments.gui.labels.Private Price List' | translate}}
      </h2>
      <table >
        <tr>
        <th>
          <!-- exam name -->
          {{'billing.gui.labels.Exam Name' | translate}}
        </th>
        <ng-container *ngIf="ls.isCardio">
          <th>
            <!-- private exam -->
            {{'appointments.gui.labels.Private' | translate}}
          </th>
          <th>
            <!-- expatriate exam -->
            {{'appointments.gui.labels.expatriate' | translate}}
          </th>
          <th>
            <!-- other exam -->
            {{'appointments.gui.labels.Other' | translate}}
          </th>
        </ng-container>
        <ng-container *ngIf="ls.isObgyn">
        <th>
          <!-- singleton  -->
          {{'appointments.gui.labels.Singleton' | translate}}
        </th>
        <th>
              <!-- twins -->
              {{'appointments.gui.labels.Twins' | translate}}
        </th>
      </ng-container>
        </tr>
         <tr [ngClass]="exam.isEditing ? 'tr-isActive' : ''" *ngFor="let exam of exams">
          <!-- <td style="width: 17%;"><select class="t-select w100"  [(ngModel)]="exam.examType" [disabled]="!exam.isEditing">
            <option *ngFor="let type of getExamTypes()" [value]="type">
             
              {{ 'appointments.gui.exams.'+type | translate }}
            </option>
          </select></td> -->
           <td style="width: 17%;"><select class="t-select w100"  [(ngModel)]="exam.examId" [disabled]="!exam.isEditing">
            <option *ngFor="let exam of examsSettings" [value]="exam.AutoIndex">
             
            {{exam.examName}} 
            </option>
          </select></td>
          <td  >
            <input class="search-patient-field  menstural-field w" type="number" [(ngModel)]="exam.examPrice"  [disabled]="!exam.isEditing">
          </td>
          <td *ngIf="ls.isObgyn">
            <input class="search-patient-field   menstural-field " type="number" [(ngModel)]="exam.examPriceTwins" [disabled]="!exam.isEditing">
          </td>
          <td *ngIf="ls.isCardio"><input class="search-patient-field   menstural-field " type="number" [(ngModel)]="exam.expatriatePrice" [disabled]="!exam.isEditing"></td>
          <td *ngIf="ls.isCardio"><input class="search-patient-field   menstural-field" type="number" [(ngModel)]="exam.otherPrice" [disabled]="!exam.isEditing"></td>
          <td>
            <button class="blue-btn" *ngIf="!exam.isEditing" (click)="editExam(exam)">
              <!-- Edit -->
              {{'appointments.gui.buttons.Edit' | translate}}
            </button>
            <button class="orange-btn" *ngIf="exam.isEditing" (click)="saveChanges(exam)">
              <!-- Save -->
              {{'appointments.gui.buttons.Save' | translate}}
            </button>
            <button class="orange-btn" (click)="deletePrice(exam)" >
              <!-- delete  -->
              {{'appointments.gui.buttons.Delete' | translate}}
            </button>
          </td>
        </tr> 
        <tr>
            <!-- <td><select class="t-select w100" [(ngModel)]="newExam.examType" >
                <option *ngFor="let type of getExamTypes()" [value]="type">
                  {{ 'appointments.gui.exams.'+type | translate }}
                </option>
              </select></td> -->
               <td style="width: 17%;"><select class="t-select w100"  [(ngModel)]="newExam.examId" >
            <option *ngFor="let exam of examsSettings" [value]="exam.AutoIndex">
             
            {{exam.examName}} 
            </option>
          </select></td>
            <td >
              <input type="number" min="0" class="search-patient-field  menstural-field w" [(ngModel)]="newExam.examPrice">
            </td>
          <td *ngIf="ls.isObgyn">
            <input type="number" min="0" class="search-patient-field  menstural-field "  [(ngModel)]="newExam.examPriceTwins" >
          </td>
          <td *ngIf="ls.isCardio"><input type="number" min="0" class="search-patient-field   menstural-field" [(ngModel)]="newExam.expatriatePrice"></td>
          <td *ngIf="ls.isCardio"><input type="number" min="0" class="search-patient-field   menstural-field" [(ngModel)]="newExam.otherPrice"></td>
           <td ><button style="white-space: nowrap;" class="orange-btn" (click)="saveNewExam()">
            <!-- Save New -->
            {{'appointments.gui.buttons.Save New' | translate}}
          </button></td>
        </tr>
      </table>
    </div>
</div>